export const SEND_CONTACT = "SEND_CONTACT";
export const SEND_CONTACT_FAIL = "SEND_CONTACT_FAIL";
export const SEND_CONTACT_SUCCESS = "SEND_CONTACT_SUCCESS";
